var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewardsBackgroundMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 835,
    height: 237,
    viewBox: "0 0 835 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.056 -16.229C377.849 -25.961 270.801 -53.2647 225.803 -65.7C199.751 -72.4584 129.744 -86.9482 58.126 -90.841C-31.3964 -95.707 -145.076 12.156 -75.4471 94.067C-5.81858 175.978 380.691 146.782 419.057 136.239C457.424 125.696 446.056 81.091 524.211 67.304C602.365 53.517 725.991 88.39 816.935 67.304C907.878 46.218 531.316 -4.06405 446.056 -16.229Z",
    fill: "url(#paint0_linear_8_620)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.362 -1.42878C304.29 -8.011 231.982 -26.4778 201.588 -34.8884C183.99 -39.4594 136.702 -49.2596 88.3266 -51.8925C27.8568 -55.1836 -48.9303 17.7694 -1.89823 73.1698C45.1339 128.57 306.21 108.823 332.126 101.693C358.041 94.562 350.362 64.3935 403.154 55.0686C455.945 45.7438 539.451 69.3301 600.88 55.0686C662.31 40.8072 407.953 6.79901 350.362 -1.42878Z",
    fill: "url(#paint1_linear_8_620)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.362 -1.42878C304.29 -8.011 231.982 -26.4778 201.588 -34.8884C183.99 -39.4594 136.702 -49.2596 88.3266 -51.8925C27.8568 -55.1836 -48.9303 17.7694 -1.89823 73.1698C45.1339 128.57 306.21 108.823 332.126 101.693C358.041 94.562 350.362 64.3935 403.154 55.0686C455.945 45.7438 539.451 69.3301 600.88 55.0686C662.31 40.8072 407.953 6.79901 350.362 -1.42878Z",
    fill: "url(#paint2_linear_8_620)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.494 124.5C592.697 115.3 642.19 103.333 666.411 98.5C674.291 132.833 685.322 204.5 666.411 216.5C642.774 231.5 527.211 204.5 517.581 195C507.951 185.5 514.079 170 557.853 164C601.626 158 583.242 136 588.494 124.5Z",
    fill: "#00575F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.695 21.9997C425.657 9.5997 334.608 -11.8336 297.838 -21.0003C257.858 -26.167 191.556 -32.0003 246.185 -14.0003C300.815 3.9997 435.287 17.4997 495.695 21.9997Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_8_620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.404 109C188.404 109 77.5111 97.8333 53.5815 92.5C39.574 94 19.9634 98.6 53.5815 105C87.1996 111.4 157.471 110.333 188.404 109Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8_620",
    x: -101,
    y: -95,
    width: 936,
    height: 249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8_620",
    x: -24.4566,
    y: -60,
    width: 642.838,
    height: 179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8_620",
    x: -24.4566,
    y: -60,
    width: 642.838,
    height: 179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_8_620",
    x: 497.65,
    y: 82.5,
    width: 195.203,
    height: 154.444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_8_620",
    x: 213.485,
    y: -38.1934,
    width: 294.21,
    height: 72.1931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_8_620",
    x: 23.0192,
    y: 80.5,
    width: 177.385,
    height: 41.5115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_8_620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_620",
    x1: -22.8698,
    y1: -46.2366,
    x2: 877.083,
    y2: 312.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00575F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_620",
    x1: 33.6162,
    y1: -21.7243,
    x2: 641.726,
    y2: 220.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11B3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00575F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_620",
    x1: 33.6162,
    y1: -21.7243,
    x2: 641.726,
    y2: 220.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00575F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsBackgroundMedium);
export default __webpack_public_path__ + "static/media/rewards-background-medium.426e4faa58cd249827655660448851dc.svg";
export { ForwardRef as ReactComponent };